import {defineMessages} from 'react-intl';

export default defineMessages({
	shopNow: {
		id: 'flyout.myAccount.orders.shopNow',
		defaultMessage: 'Shop now'
	}
});
